/**
 * <ready-made-item>: one listing on the "Available now" page
 * (sections/ready-made-list.liquid). Liquid renders the state — the variant
 * id, whether it is for sale and whether it has sold out — as data attributes,
 * with the gated PLACE IN BAG button; this element only places the variant in
 * the bag when that button is clicked and opens the drawer. cart.js refuses
 * the add unless the Ordering enabled setting is on; the check here is the
 * same one, in front of it.
 */

import { addLines } from "@theme/cart";

class ReadyMadeItem extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  get #canAdd() {
    return (
      document.documentElement.dataset.orderingEnabled === "true" &&
      this.dataset.available === "true" &&
      this.dataset.soldOut !== "true" &&
      Boolean(this.dataset.variantId)
    );
  }

  #showError(message) {
    const error = this.querySelector("[data-error]");
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  }

  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest("[data-add]");
    if (!button || !this.contains(button)) return;
    event.preventDefault();
    if (button.getAttribute("aria-disabled") === "true") return;
    this.#add(button);
  };

  async #add(button) {
    if (this.#busy || !this.#canAdd) return;

    this.#busy = true;
    button.setAttribute("aria-disabled", "true");
    this.#showError("");
    try {
      await addLines([{ id: Number(this.dataset.variantId), quantity: 1 }]);
      document.querySelector("bag-drawer")?.open(button);
    } catch (error) {
      this.#showError(error instanceof Error ? error.message : "This Moonphase could not be placed in your bag.");
    } finally {
      this.#busy = false;
      button.removeAttribute("aria-disabled");
    }
  }
}

if (!customElements.get("ready-made-item")) {
  customElements.define("ready-made-item", ReadyMadeItem);
}
